export type Mode = 'guided' | 'canvas'

/** Width threshold decided in docs/mobile-canvas-implementation-plan.md §15: below 1024,
 *  the desktop canvas is already observed to behave badly (portrait dead zones,
 *  self-overlapping HUD) even with full pointer/keyboard support. */
const WIDTH_THRESHOLD = 1024

export function detectMode(search: string, innerWidth: number): Mode {
  const view = new URLSearchParams(search).get('view')
  if (view === 'guided') return 'guided'
  if (view === 'canvas') return 'canvas'
  return innerWidth < WIDTH_THRESHOLD ? 'guided' : 'canvas'
}

export type ChromeVariant = 'a' | 'b'

export function getChromeVariant(search: string): ChromeVariant {
  return new URLSearchParams(search).get('chrome') === 'b' ? 'b' : 'a'
}

export function isVtestMode(search: string): boolean {
  return new URLSearchParams(search).get('vtest') === '1'
}
